var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "请查询用户进行切换",
        width: 450,
        visible: _vm.visible,
        closable: false,
        maskClosable: false,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form",
        [
          _c(
            "a-form-item",
            {
              staticStyle: { "margin-bottom": "10px" },
              attrs: { labelCol: { span: 4 }, wrapperCol: { span: 20 } },
            },
            [
              _c(
                "a-tooltip",
                { attrs: { placement: "topLeft" } },
                [
                  _c("template", { slot: "title" }, [
                    _c("span", [_vm._v("运维人员切换用户查看")]),
                  ]),
                  _c("a-avatar", {
                    staticStyle: { backgroundcolor: "#87d068" },
                    attrs: { icon: "gold" },
                  }),
                ],
                2
              ),
              _c(
                "a-select",
                {
                  staticStyle: { "margin-left": "10px", width: "80%" },
                  attrs: {
                    "show-search": "",
                    "default-active-first-option": false,
                    "show-arrow": false,
                    "filter-option": false,
                    "not-found-content": null,
                    allowClear: "",
                    placeholder: "请输入用户姓名",
                  },
                  on: { search: _vm.handleSearch },
                  model: {
                    value: _vm.userId,
                    callback: function ($$v) {
                      _vm.userId = $$v
                    },
                    expression: "userId",
                  },
                },
                [
                  _c("a-icon", {
                    attrs: { slot: "suffixIcon", type: "gold" },
                    slot: "suffixIcon",
                  }),
                  _vm._l(_vm.userList, function (d) {
                    return _c("a-select-option", { attrs: { value: d.id } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(d.realname) +
                          " - " +
                          _vm._s(d.name) +
                          "\n        "
                      ),
                    ])
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }